<template>
  <div class="fukuantu-page">
    <div class="main-container">
      <!-- 头部 -->
      <div class="header">
        <svg width="18" height="18" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" @click="goBack">
          <path d="M778.671 926.323a56.811 56.811 0 1 1-80.33 80.331L243.85 552.165a56.811 56.811 0 0 1 0-80.33l454.49-454.49a56.811 56.811 0 1 1 80.33 80.331L364.348 512 778.67 926.323z"></path>
        </svg>
        <div class="header-title">付款图</div>
      </div>

      <!-- 平台选择器 -->
      <div class="platform-selector">
        <div class="platform-item" @click="selectPlatform('alipay')">支付宝</div>
        <div class="platform-item" @click="selectPlatform('wechat')">微信</div>
        <div class="platform-slider" :class="currentPlatform"></div>
      </div>

      <!-- 表单区域 -->
      <div class="form-section">
        <div class="form-item">
          <label>金额</label>
          <input type="text" v-model="form.amount" placeholder="输入金额">
        </div>
        <div class="form-item" v-show="currentPlatform === 'alipay'">
          <label>负号</label>
          <select v-model="form.negativeSign">
            <option value="-">带负号</option>
            <option value="">不带负号</option>
          </select>
        </div>
        <div class="form-item">
          <label>商户名称</label>
          <input type="text" v-model="form.merchant" placeholder="输入商户名称">
        </div>
        <div class="form-item">
          <label>说明(可选)</label>
          <input type="text" v-model="form.description" placeholder="输入说明">
        </div>
        <div class="form-item">
          <label>付款时间</label>
          <input type="datetime-local" v-model="form.paymentTime">
        </div>
        <div class="form-item">
          <label>图标</label>
          <label class="upload-btn" for="icon-upload">上传</label>
          <input type="file" id="icon-upload" class="file-input" accept="image/*" @change="handleIconUpload">
        </div>
      </div>

      <!-- 预览区域 -->
      <div class="preview-container" :class="currentPlatform">
        <!-- 支付宝预览 -->
        <div v-show="currentPlatform === 'alipay'" class="alipay-preview active">
          <div class="alipay-header">
            <svg viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" width="36" height="36">
              <path d="M635.733333 785.066667c-8.533333 0-12.8-4.266667-21.333333-8.533334l-247.466667-247.466666c-12.8-12.8-12.8-29.866667 0-38.4l243.2-243.2c12.8-12.8 29.866667-12.8 38.4 0s12.8 29.866667 0 38.4L426.666667 507.733333l230.4 230.4c12.8 12.8 12.8 29.866667 0 38.4-8.533333 4.266667-12.8 8.533333-21.333334 8.533334z" fill="#111111"></path>
            </svg>
            <div class="alipay-title">账单详情</div>
            <div style="height: 23px;">全部账单</div>
          </div>

          <!-- 支付宝内容区域 - 垂直排列 -->
          <div class="alipay-content-vertical">
            <img class="alipay-icon" :src="iconPreview" alt="图标">
            <div class="alipay-merchant">{{ form.merchant || '商户名称' }}</div>
            <div class="alipay-amount">{{ alipayAmountDisplay }}</div>
            <div class="alipay-status">交易成功</div>
          </div>

          <div class="alipay-info-item">
            <div class="alipay-info-label">订单金额</div>
            <div class="alipay-info-value">{{ form.amount || '0.00' }}元</div>
          </div>
          <div class="alipay-info-item">
            <div class="alipay-info-label">支付时间</div>
            <div class="alipay-info-value">{{ formattedPaymentTime }}</div>
          </div>
          <div class="alipay-info-item">
            <div class="alipay-info-label">付款方式</div>
            <div class="alipay-info-value">账户余额</div>
          </div>

          <div class="alipay-more">
            <div>更多</div>
            <svg viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" width="14" height="14">
              <path d="M540.672 761.344a26.112 26.112 0 0 1-18.944-8.704L176.128 368.64a25.6 25.6 0 1 1 37.888-34.304l326.656 363.008 326.656-363.008a25.6 25.6 0 0 1 37.888 34.304l-345.6 384a26.112 26.112 0 0 1-18.944 8.704z" fill="#999999"></path>
            </svg>
          </div>

          <!-- 底部预览图 - 只在支付宝预览区内 -->
          <div class="preview-image">
            <img src="/zfb.png" alt="">
          </div>
        </div>

        <!-- 微信预览 -->
        <div v-show="currentPlatform === 'wechat'" class="wechat-preview active">
          <div class="wechat-cover"></div>
          <div class="wechat-success">
            <svg class="wechat-success-icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" width="18" height="18">
              <path d="M0 488.96v-30.72C2.56 430.08 7.68 404.48 15.36 378.88c20.48-66.56 53.76-122.88 99.84-171.52C179.2 138.24 256 94.72 340.48 66.56c48.64-15.36 97.28-23.04 145.92-25.6 40.96-2.56 79.36 0 120.32 7.68 33.28 5.12 64 12.8 97.28 25.6 79.36 28.16 148.48 71.68 207.36 133.12 7.68 7.68 12.8 15.36 20.48 23.04-2.56 0-2.56 2.56-5.12 2.56-20.48 10.24-40.96 20.48-61.44 28.16-143.36 66.56-286.72 133.12-430.08 197.12-28.16 12.8-56.32 10.24-81.92-5.12-20.48-12.8-38.4-25.6-58.88-38.4-12.8-10.24-25.6-17.92-40.96-28.16-12.8-7.68-20.48-2.56-20.48 12.8v2.56c2.56 12.8 5.12 25.6 10.24 38.4 25.6 61.44 51.2 120.32 76.8 181.76 7.68 17.92 20.48 25.6 35.84 23.04 10.24 0 20.48-2.56 28.16-7.68 30.72-15.36 58.88-33.28 87.04-51.2 156.16-92.16 309.76-184.32 465.92-276.48 10.24-7.68 23.04-12.8 33.28-20.48 0 2.56 2.56 2.56 2.56 5.12 5.12 10.24 10.24 17.92 12.8 28.16 28.16 61.44 40.96 125.44 35.84 192-2.56 28.16-7.68 56.32-15.36 84.48-17.92 61.44-48.64 115.2-92.16 163.84-51.2 56.32-115.2 99.84-184.32 128-40.96 15.36-81.92 28.16-122.88 35.84-28.16 5.12-56.32 7.68-81.92 7.68h-46.08c-20.48-2.56-40.96-2.56-58.88-5.12-30.72-5.12-61.44-12.8-89.6-23.04H322.56c-12.8 7.68-23.04 15.36-35.84 23.04-28.16 17.92-53.76 33.28-81.92 48.64-5.12 2.56-12.8 5.12-17.92 5.12s-10.24-2.56-10.24-10.24c0-5.12 0-12.8 2.56-17.92 5.12-38.4 12.8-74.24 20.48-112.64 0-5.12 0-7.68-5.12-10.24-15.36-12.8-30.72-23.04-46.08-38.4-51.2-46.08-92.16-102.4-117.76-166.4C20.48 599.04 12.8 568.32 7.68 537.6c-2.56-12.8-2.56-25.6-2.56-40.96-5.12 0-5.12-2.56-5.12-7.68z" fill="#09bb07"></path>
            </svg>
            <div style="letter-spacing: 1px;">支付成功</div>
          </div>
          <div class="wechat-merchant">{{ form.merchant || '商户名称' }}</div>
          <div class="wechat-amount-section">
            <div class="wechat-amount-symbol">￥</div>
            <div class="wechat-amount-value">{{ wechatAmountDisplay }}</div>
          </div>
          <div class="wechat-complete-btn">完成</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, reactive, computed, onMounted } from 'vue'

export default {
  name: 'Fukuantu',
  emits: ['close'],
  setup(props, { emit }) {
    // 当前平台
    const currentPlatform = ref('alipay')

    // 默认图标
    const defaultIcon = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMjAiIGN5PSIyMCIgcj0iMjAiIGZpbGw9IiNGMEYwRjAiLz4KPHBhdGggZD0iTTE2LjUgMTdIMjMuNVYyM0gxNi41VjE3WiIgZmlsbD0iIzk5OTk5OSIvPgo8cGF0aCBkPSJNMTcgMTcuNUgyM1YxOC41SDE3VjE3LjVaIiBmaWxsPSIjOTk5OTk5Ii8+CjxwYXRoIGQ9Ik0xNyAyMS41SDIzVjIyLjVIMTdWMjEuNVoiIGZpbGw9IiM5OTk5OTkiLz4KPC9zdmc+Cg=='

    // 图标预览
    const iconPreview = ref(defaultIcon)

    // 表单数据
    const form = reactive({
      amount: '',
      negativeSign: '-',
      merchant: '',
      description: '',
      paymentTime: ''
    })

    // 支付宝金额显示
    const alipayAmountDisplay = computed(() => {
      const amount = form.amount || '0.00'
      return `${form.negativeSign}${amount}`
    })

    // 微信金额显示（不带负号）
    const wechatAmountDisplay = computed(() => {
      const amount = form.amount || '0.00'
      return amount.replace('-', '')
    })

    // 格式化付款时间
    const formattedPaymentTime = computed(() => {
      if (!form.paymentTime) {
        return '2025年01月01日 00:00'
      }
      const date = new Date(form.paymentTime)
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      const hours = String(date.getHours()).padStart(2, '0')
      const minutes = String(date.getMinutes()).padStart(2, '0')
      return `${year}年${month}月${day}日 ${hours}:${minutes}`
    })

    // 平台切换
    const selectPlatform = (platform) => {
      currentPlatform.value = platform
    }

    // 返回
    const goBack = () => {
      emit('close')
    }

    // 图标上传
    const handleIconUpload = (e) => {
      const file = e.target.files[0]
      if (file) {
        const reader = new FileReader()
        reader.onload = (e) => {
          iconPreview.value = e.target.result
        }
        reader.readAsDataURL(file)
      }
    }

    // 初始化默认时间
    const initDefaultTime = () => {
      const now = new Date()
      const year = now.getFullYear()
      const month = String(now.getMonth() + 1).padStart(2, '0')
      const day = String(now.getDate()).padStart(2, '0')
      const hours = String(now.getHours()).padStart(2, '0')
      const minutes = String(now.getMinutes()).padStart(2, '0')
      form.paymentTime = `${year}-${month}-${day}T${hours}:${minutes}`
    }

    onMounted(() => {
      initDefaultTime()
    })

    return {
      currentPlatform,
      form,
      iconPreview,
      alipayAmountDisplay,
      wechatAmountDisplay,
      formattedPaymentTime,
      selectPlatform,
      goBack,
      handleIconUpload
    }
  }
}
</script>

<style scoped>
:root {
  --color-blue: #0066ff;
}

.fukuantu-page {
  height: 100%;
  width: 100%;
  background: #fff;
  overflow: hidden;
}

.main-container {
  height: 100%;
  width: 100%;
  background: #f5f5f5;
  overflow-y: scroll;
  overscroll-behavior: none;
}

/* 头部 */
.header {
  background: #f5f5f5;
  padding-left: 8px;
  align-items: center;
  display: flex;
  height: 49px;
  border-bottom: 1px solid #dbdbdb;
}

.header svg {
  cursor: pointer;
}

.header-title {
  margin-left: 12px;
  font-weight: bold;
}

/* 平台选择器 */
.platform-selector {
  display: flex;
  background-color: #dbdbdb;
  position: relative;
  box-sizing: border-box;
  font-size: 0.9rem;
  flex-wrap: wrap;
  border: 2px solid #dbdbdb;
  margin: 12px;
  border-radius: 4px;
  overflow: hidden;
}

.platform-item {
  flex: 1;
  text-align: center;
  min-height: 36px;
  max-height: 36px;
  line-height: 36px;
  z-index: 2;
  color: #555555;
  min-width: 50%;
  max-width: 50%;
  cursor: pointer;
}

.platform-slider {
  content: "";
  width: 50%;
  min-height: 36px;
  max-height: 36px;
  background-color: #f5f5f5;
  position: absolute;
  left: 0;
  transition: transform 0.1s linear;
  border-radius: 0;
}

.platform-slider.alipay {
  transform: translateX(0%);
}

.platform-slider.wechat {
  transform: translateX(100%);
}

/* 表单区域 */
.form-section {
  background: #fff;
  margin: 0 12px;
  border-radius: 8px;
  overflow: hidden;
}

.form-item {
  display: flex;
  align-items: center;
  border-bottom: 0.5px solid #dbdbdb;
  background: #fff;
  padding: 0 16px;
  font-size: 0.95rem;
}

.form-item label {
  word-break: keep-all;
  min-width: 6em;
}

.form-item input,
.form-item select {
  appearance: none;
  -webkit-appearance: none;
  padding: 12px 0;
  background: transparent;
  width: 100%;
  font-size: inherit;
  color: #2d2d2d;
  border: none;
  outline: none;
}

/* 预览区域 */
.preview-container {
  width: 100%;
  font-size: 14px;
  max-height: 100%;
  min-height: 100%;
  overflow: hidden;
  margin-top: 6px;
  position: relative;
}

.preview-container.alipay {
  background: #f5f5f5;
}

.preview-container.wechat {
  background: #fff;
}

/* 支付宝预览样式 */
.alipay-preview {
  background: #fff;
  margin: 0 12px;
  position: relative;
  padding: 21px 14px;
  border-radius: 8px;
}

.alipay-header {
  height: 44px;
  padding: 0 14px;
  margin-bottom: 6px;
  padding-left: 4px;
  font-size: 1rem;
  color: #2d2d2d;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.alipay-title {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  font-weight: bold;
  font-size: 18px;
  color: #000;
}

.alipay-icon {
  border-radius: 50%;
  width: 40px;
  height: 40px;
  object-fit: cover;
  margin-bottom: 12px;
}

/* 支付宝内容区域 - 垂直排列 */
.alipay-content-vertical {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 14px;
  margin-bottom: 20px;
}

.alipay-merchant {
  font-weight: bold;
  font-size: 16px;
  margin-bottom: 8px;
}

@font-face {
  font-family: alipaynumber;
  src: url(data:font/woff2;base64,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) format("woff2");
}

.alipay-amount {
  font-family: alipaynumber;
  font-size: 33px;
  font-weight: bold;
  margin-bottom: 8px;
}

.alipay-status {
  color: #030303;
  font-size: 16px;
}

.alipay-info-item {
  align-items: flex-start;
  width: 100%;
  font-size: 13px;
  display: flex;
}

.alipay-info-item + .alipay-info-item {
  margin-top: 8px;
}

.alipay-info-label {
  color: #999;
  min-width: 100px;
}

.alipay-info-value {
  word-break: break-all;
}

.alipay-more {
  font-size: 13px;
  color: #999;
  gap: 1px;
  margin-top: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* 微信预览样式 */
.wechat-preview {
  background: #fff;
  border-radius: 8px;
  padding: 0;
  padding-bottom: 160px; /* 给底部按钮留出更多空间 */
  position: relative;
  overflow: visible; /* 允许按钮超出显示 */
  min-height: 500px;
  margin: 0 12px;
}

.wechat-cover {
  height: 100%;
  width: 100%;
  position: absolute;
  left: 0;
  top: 0;
  object-fit: cover;
  overflow: hidden;
  opacity: 0.2;
}

.wechat-cover img {
  width: 100%;
  transform: translateY(-48px);
  object-fit: cover;
}

.wechat-success {
  color: #09bb07;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 2vh 0;
  font-size: 1.03rem;
  gap: 0.75rem;
  font-weight: bold;
  position: relative;
  z-index: 1;
}

.wechat-success-icon {
  transform: translateX(0.25rem);
}

.wechat-merchant {
  text-align: center;
  width: 100%;
  font-size: 1.04rem;
  margin-top: 9.6vh;
  position: relative;
  z-index: 1;
}

.wechat-amount-section {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
  margin-top: 1.046rem;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  color: #000;
  position: relative;
  z-index: 1;
}

.wechat-amount-symbol {
  font-size: 3.25rem;
}

.wechat-amount-value {
  font-size: 3.25rem;
}

.wechat-complete-btn {
  background-color: #f2f2f2;
  padding: 0.823rem 0;
  border-radius: 8px;
  font-size: 1.05rem;
  text-align: center;
  font-weight: bold;
  position: fixed;
  left: 50%;
  transform: translateX(-50%);
  width: 50vw;
  bottom: 5vh;
  word-break: keep-all;
  overflow: hidden;
  z-index: 1;
}

@font-face {
  font-family: fa1;
  src: url(https://rr1114.cn-nb1.rains3.com/assets/WeChatSansStd-Medium-v5yzLSK0.otf) format("opentype");
}

/* 文件上传 */
.file-input {
  display: none;
}

.upload-btn {
  color: #0066ff;
  cursor: pointer;
}

/* 底部预览图 */
.preview-image {
  width: 100%;
  font-size: 14px;
  max-height: 100%;
  min-height: 100%;
  overflow: hidden;
  margin-top: 6px;
  position: relative;
}

.preview-image img {
  width: 100%;
  max-width: 377.333px;
}
</style>
